import { createApiSlice } from "@common";
import {  LMS_LEAVE_TRANSACTION } from "@routes";

const apiConfig = [
  {
    name: "addLeaveTransaction",
    method: "post",
    url:  LMS_LEAVE_TRANSACTION,
    stateKey: "message"
  },
  
  {
    name: "getLeaveTransaction",
    method: "get",
    url:  LMS_LEAVE_TRANSACTION,
    stateKey: "data"
  },
  {
    name: "updateLeaveTransaction",
    method: "put",
    url:  LMS_LEAVE_TRANSACTION,
    stateKey: "message"
  },
  {
    name: "deleteLeaveTransaction",
    method: "delete",
    url:  LMS_LEAVE_TRANSACTION,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData: (state, action) => { state.additionalData = action.payload; },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "LeaveTransaction",
  apiConfig,
  customReducers
);
const LeaveTransactionSlice = slice;

export default LeaveTransactionSlice.reducer;

export const {
  addLeaveTransaction,
  getLeaveTransaction,
 
  updateLeaveTransaction,
  deleteLeaveTransaction
} = thunks;
export const { rowSelect } = actions;
